module.exports = __webpack_public_path__ + "static/media/Skin_tone_5.d09ea584.svg";